var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('tts-mode-btn',{staticClass:"tts-mode-btn",attrs:{"ttsMode":_vm.ttsMode},on:{"tts-mode-changed":_vm.handleTTSMode}})
}
var staticRenderFns = []

export { render, staticRenderFns }